(function () {
  function correctPostSubmitScroll() {
    // If we got here via Shopify's full-page POST flow (the AJAX submit
    // below was bypassed, e.g. captcha challenge, JS error, or a bot
    // that doesn't run JS), Shopify will have appended `#contact_form`
    // to the URL. Chrome then tries to scroll to that anchor — which
    // doesn't exist as an element — and ends up at an inconsistent
    // position. Scroll the user back to the newsletter section with
    // some breathing room above, and strip the hash so a subsequent
    // refresh doesn't re-trigger this. No-op on a clean page load.
    if (!/(?:[?&])customer_posted=true(?:&|$)/.test(location.search)) return;

    var newsletter = document.querySelector('.albirouhi-footer-newsletter');
    if (newsletter) {
      var rect = newsletter.getBoundingClientRect();
      var targetY = Math.max(0, window.scrollY + rect.top - 120);
      window.scrollTo({ top: targetY });
    }
    if (location.hash === '#contact_form') {
      history.replaceState(null, '', location.pathname + location.search);
    }
  }

  function init() {
    correctPostSubmitScroll();

    var form = document.querySelector('.albirouhi-footer-form');
    if (!form) return;

    var fieldHelp = form.querySelector('.field-help');
    var input = form.querySelector('input[type="email"]');
    var button = form.querySelector('button[type="submit"]');

    var SUCCESS_TEXT = 'welcome. the next letter is on its way.';
    var ERROR_TEXT = 'that email looks off — try again?';
    var EMPTY_TEXT = "we'll need an address to send the moon notes to.";

    function showMessage(text, isSuccess) {
      if (!fieldHelp) return;
      fieldHelp.textContent = text;
      fieldHelp.className = 'field-help is-shown' + (isSuccess ? ' is-success' : '');
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var email = (input.value || '').trim();
      if (!email) {
        showMessage(EMPTY_TEXT, false);
        return;
      }
      if (!/^\S+@\S+\.\S+$/.test(email)) {
        showMessage(ERROR_TEXT, false);
        return;
      }

      button.disabled = true;
      var formData = new FormData(form);

      fetch(form.action, {
        method: 'POST',
        body: formData,
        headers: { Accept: 'text/html' },
        redirect: 'follow',
        credentials: 'same-origin',
      })
        .then(function () {
          showMessage(SUCCESS_TEXT, true);
          form.reset();
        })
        .catch(function () {
          showMessage(ERROR_TEXT, false);
        })
        .finally(function () {
          button.disabled = false;
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
